module.exports = __webpack_public_path__ + "img/Chile.b13812ad.svg";